module.exports = __webpack_public_path__ + "/8b0581c24553d82146f7c5d81a9f84f6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/g2_crowd_smallbiz_2016.png
 ** module id = 1023
 ** module chunks = 0
 **/